export default __webpack_public_path__ + "media/src/features/home-page-location-filter-widget/assets/mapWithPin-4a7197b2c4a232d4bb579ddcbf783794.svg";